<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel()">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ props.title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="props.mustHaveLeastOneCheckBox && !hasAtLeastOneCheckBox" @click="confirm()" :strong="true">{{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <div id="repmanager-container">

      <div v-for="(item,i) in props.displayArray" :key="item.id">
        <div class="form-check">
              <input  class="form-check-input" type="checkbox" value="" 
                      id=item.name @change="onCheckboxClick($event,item.index)"
                      v-model="item.selected">

              <label class="form-check-label" for=item.name>
                {{ item.name }}
              </label>
        </div>
      </div>
    </div>
  </ion-content>
</template>

<script  setup>
  import {
    IonRadio,
    IonRadioGroup,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t } from '@/composables/translateText.js'

  const props = defineProps({
    title : {
      type : String,
      default : "TITLE"
    },
    displayArray : {
      type : Array,
      default : []
    },
    mustHaveLeastOneCheckBox : {
      type : Boolean,
      default : true
    }
	})

  //console.log("props displayArray",props.displayArray)
  //console.log("Props title",props.title)

  const hasAtLeastOneCheckBox = ref(true)
  const selectedValue = ref(false)

  function cancel() {
    modalController.dismiss(null, 'cancel');
  }

  function confirm() {
    var results = []

    for (var i=0; i < props.displayArray.length; i++)
      if (props.displayArray[i].selected)
          results.push(props.displayArray[i].radio)

    const result = results.join(",")

    //console.log("CONFIRM",result)
    modalController.dismiss(result, 'confirm');
  }

  function onCheckboxClick(event,index) {
    hasAtLeastOneCheckBox.value = false
    for (var i=0; i < props.displayArray.length; i++)
      if (props.displayArray[i].selected) {
        hasAtLeastOneCheckBox.value = true
        break
      }
  }

</script>

<style scoped>

#repmanager-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin : 30px auto;
  padding : 15px 15px;
  line-height: 1.4em;
  width : 600px;
  height: calc(100vh - 125px);
  overflow-y: auto;
}

/* from bootstrap */

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5em;
    margin-bottom: 0.125rem;
    line-height: 1.4em;
}

.form-check-input[type=checkbox] {
    border-radius: 0.25em;
}

.form-check-input:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
}

.form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: .5;
}

.form-check .form-check-input {
    float: left;
    margin-left: -1.5em;
}

.form-check-input {
    width: 1em;
    height: 1em;
    margin-top: 0.25em;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    border: 1px solid rgba(0,0,0,.25);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

.repmanager-center-text {
  text-align: center;
  margin-bottom : 10px;
  font-style :italic;
}

.repmanager-heading-color {
  background: #4c6ca0;
  color : white;
  text-align : center;
}

/* from bootstrap */

.form-check-input:checked[type=radio] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-label {
margin-left : 20px;
}
.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: .25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0,0,0,.25);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.btn-center {
  margin-left : 30px;
  margin-bottom : 10px;
}

#reptree-container {
  position : relative;
}

</style>
